import { useSelector } from "react-redux"
import { DataGrid } from "../../components"
import { getLocalized } from "../../redux/localization"
import { adminAccountCallLogs,  } from "../../services/urls"
import { CreateAccountCallLog } from "./create"
import {  AccountCallLogsDetail } from "./detail"

export const CallLogs = () => {
    const localize = useSelector(getLocalized);
    const columns = [
        {
            dataField: "Account.AccountName",
            caption:localize.getString("accountName")
        },
        {
            dataField: "Account.Email",
            caption: localize.getString("email")
        },
        {
            dataField: "Account.Phone",
            caption: localize.getString("phone")
        },
        {
            dataField: "TalkedWith",
            caption: localize.getString("talkedWidth")
        },
        {
            dataField: "AccountCallLogStatus",
            caption: localize.getString("callStatus")
        },
        {
            dataField: "Note",
            caption: localize.getString("note")
        },
        
        {
            dataField: "NextCallNote",
            caption: localize.getString("nextCallNote")
        },
       
        
       
    ]
    return <DataGrid
        url={adminAccountCallLogs}
        getByIdUrl={adminAccountCallLogs}
        columns={columns}
        refObject={{}}
        create={{
            width: "45%",
            height: "72%",
            createUrl: adminAccountCallLogs,
            title: localize.getString("createCallLog"),
            component: CreateAccountCallLog,
           
        }}
        details={{
            width: "50%",
            height: "50%",
            getByIdUrl: adminAccountCallLogs,
            title: localize.getString("callLogDetail"),
            component: AccountCallLogsDetail,
        }}
        remove={{
            url:adminAccountCallLogs
        }}
        edit={{   
            component : CreateAccountCallLog, 
            width:"50%",
            height : "80%",
            editUrl :adminAccountCallLogs,
            title : localize.getString("editCallLog"),
            
            
        }}
        title={localize.getString("callLogs")}
    />
}